<template>
  <section class="page-inbound" :class="{ 'rtl': locale === 'ar' }">
    <section class="stepQuote">
      <div class="containerMini">
        <div class="headerBlock_rr">
          <BaseBackButton :back="back"/>
          <slot name="logo">
            <Logo @click="$emit('clickLogo')">
              <template v-if="$slots['logo-first-line']" #logo-first-line>
                <slot name="logo-first-line"></slot>
              </template>

              <template v-if="$slots['logo-second-line']" #logo-second-line>
                <slot name="logo-second-line"></slot>
              </template>
            </Logo>
          </slot>
        </div>
        <BaseError :message="errorMessage" v-if="errorMessage" @reload="onReload()" />
        <template v-else>
          <ProgressBar v-if="steps || step" :steps="steps" :step="step" :from-step="fromStep"/>
          <div class="boxForm">
            <Loader v-if="loading" />
            <template v-else>
              <BaseFormHeader>
                <slot name="header"></slot>
              </BaseFormHeader>
              <slot></slot>
            </template>
          </div>
        </template>
      </div>
    </section>
    <ContactUs @click="showNeedHelpPopup()" />
    <ContactUsPopup v-model="needHelp" :excluded-countries="excludedCountries" />
  </section>
</template>

<script>
import Logo from './Logo.vue'
import ProgressBar from './ProgressBar.vue'
import ContactUs from './need-help/ContactUs.vue'
import ContactUsPopup from './need-help/ContactUsPopup.vue'
import BaseFormHeader from './BaseFormHeader.vue'
import Loader from './Loader.vue'
import BaseError from './errors/BaseError.vue'
import BaseBackButton from './buttons/BaseBackButton.vue'
export default {
  name: 'BaseForm',
  props: {
    steps: Number,
    step: Number,
    loading: Boolean,
    back: Function,
    errorMessage: String,
    excludedCountries: Array
  },
  components: {
    Logo,
    ProgressBar,
    ContactUs,
    BaseFormHeader,
    Loader,
    BaseError,
    ContactUsPopup,
    BaseBackButton
  },
  computed: {
    locale () {
      return this.$i18n.locale
    }
  },
  data () {
    return {
      needHelp: false,
      fromStep: null
    }
  },
  created () {
    const lastStep = this.getLastStep()
    this.fromStep = lastStep || (this.step === 1 ? 1 : this.step - 1)
    this.setLastStep(this.step)
  },
  methods: {
    onReload () {
      this.$router.go()
    },
    showNeedHelpPopup () {
      this.needHelp = true
    },
    getLastStep () {
      return +sessionStorage.getItem('boatInsuranceLastStep') || null
    },
    setLastStep (step) {
      sessionStorage.setItem('boatInsuranceLastStep', step)
    }
  }
}
</script>
